module.exports = __webpack_public_path__ + "static/media/Success-new-gradient.c888f5e3.svg";